import { useQuoteStore } from '../stores/Quotes';
import ExitButton from './ExitButton';
import { useAppStore } from '../stores/AppStore';

export default function Header({ page }) {
    const { setShowDrawer } = useAppStore(state => state);
    const siteLink = window.data.pd+'/power-up/';

    return (
        <div className="hidden md:flex w-full py-4 justify-between bg-calm fixed top-0">
            <div className="hidden md:block ml-16 flex-shrink-0" style={{ width: '196px' }}>
                {/* <img 
                    src="/build/assets/show-drawer.svg" 
                    alt="show drawer" 
                    className="object-contain w-[25px] h-[17px] absolute top-[15px] left-5 cursor-pointer" 
                    onClick={() => setShowDrawer(true)}
                /> */}
            </div>


            <div className="hidden md:block">
                { page && !page.hideExitButton && <ExitButton siteLink={siteLink} /> }
            </div>
        </div>
    );
}

const Quotes = () => {  
    const { selectedQuote } = useQuoteStore(state => state);

    return (
        <div>
            <p>{ selectedQuote }</p>
        </div>
    );
}